<template>
	<div id="blog-index">
		<section class="banner" :style="headingBgCss">
			<div class="container">
				<p class="pre-title">
					<span>{{ acf.pre_title }}</span>
				</p>
				<h1 class="title">{{ acf.page_title }}</h1>
				<div
					class="heading-text desktop-only"
					v-html="acf.heading_text"
				></div>
			</div>
			<div class="bn_corner desktop-only"></div>
			<div class="bn_corner bn_corner-white mobile-only"></div>
		</section>

		<section
			class="mobile-only mobile-heading-text-container"
			style="background: white"
		>
			<div class="container">
				<div
					class="heading-text ta-center"
					v-html="acf.heading_text"
				></div>
			</div>
		</section>

		<section class="featured" v-if="acf.featured_posts">
			<div class="container">
				<h3 class="ta-center fw-bold">{{ acf.featured_title }}</h3>
				<div class="posts">
					<FeaturedPost
						v-for="post in acf.featured_posts"
						:key="post.ID"
						:post="post"
					/>
				</div>
			</div>
		</section>

		<a id="scroll-after-pagination-nav"></a>

		<section class="posts-by-cat">
			<div class="container">
				<div class="categories-container">
					<p>סנן לפי</p>
					<div class="categories-scroll-container">
						<button
							class="slider-nav next"
							@click="scrollCategories(-150)"
						>
							<span></span>
						</button>
						<button
							class="slider-nav prev"
							@click="scrollCategories(150)"
						>
							<span></span>
						</button>
						<ul class="categories">
							<li class="category">
								<router-link
									:to="{
										name: 'blog',
										params: { noScroll: true },
									}"
									tag="button"
									:class="{ selected: !selectedPostCat }"
								>
									כל המתכונים
								</router-link>
							</li>
							<li
								class="category"
								v-for="category in wpData.pageData
									.post_categories"
								:key="category.term_id"
							>
								<router-link
									:to="{
										name: 'blog-posts-by-cat',
										params: {
											catSlug: decodeURI(category.slug),
											noScroll: true,
										},
									}"
									tag="button"
									:class="{
										selected:
											selectedPostCat ===
											category.term_id,
									}"
								>
									{{ category.name }}
								</router-link>
							</li>
						</ul>
					</div>
				</div>
				<div class="posts" v-if="posts.length > 0">
					<BlogPost
						v-for="post in posts"
						:key="post.ID"
						:post="post"
					/>
				</div>
				<div class="loader" v-if="posts.length === 0">
					<img
						:src="wpData.assets_url + '/layout/ajax-loader.gif'"
						alt=""
					/>
				</div>
			</div>
		</section>

		<Pagination
			:max_num_pages="max_num_pages"
			:catSlug="catSlug"
			:page="page"
		/>
	</div>
</template>

<script>
	import BlogPost from "../components/Blog/BlogPost.vue";
	import FeaturedPost from "../components/Blog/FeaturedPost.vue";
	import Pagination from "../components/Blog/Pagination.vue";

	export default {
		data() {
			return {
				wpData: window.wpData,
				acf: { ...window.wpData.pageData.acf },
				posts: window.wpData.pageData.posts,
				selectedPostCat: null,
				max_num_pages: window.wpData.pageData.max_num_pages,
			};
		},
		created() {},
		mounted() {
			if (this.catSlug) {
				this.selectedPostCat = this.catSlugToID(this.catSlug);
			}
			if (this.page) {
				this.getPosts({
					cat_id: this.selectedPostCat,
					page: this.page,
				});
			}
		},
		computed: {
			catSlug() {
				return this.$route.params.catSlug;
			},
			page() {
				return this.$route.params.page;
			},
			headingBgCss() {
				return `background-image:url('${this.acf.heading_image.url}')`;
			},
		},
		watch: {
			catSlug: function (id) {
				if (id !== "") {
					this.selectedPostCat = this.catSlugToID(id);
				}
			},
			page: function (page) {
				this.getPosts({ cat_id: this.selectedPostCat, page: page });
			},
			selectedPostCat: function (cat_id) {
				this.getPosts({ cat_id: cat_id });
			},
		},
		methods: {
			scrollCategories(num) {
				const el = document.querySelector(
					"#blog-index section.posts-by-cat .categories"
				);
				el.scroll({
					top: 0,
					left: el.scrollLeft + num,
					behavior: "smooth",
				});
			},
			getPosts(args = { page: 1, cat_id: 0 }) {
				if (this.page) {
					args.page = this.page;
				}
				this.posts = [];
				fetch(
					`${wpData.ajax_url}?action=getBlogPosts&page=${args.page}&cat_id=${args.cat_id}`
				)
					.then((raw) => raw.json())
					.then((r) => {
						this.posts = r.data.posts;
						this.max_num_pages = r.data.max_num_pages;
					});
			},
			catSlugToID(slug) {
				const matchedCat = this.wpData.pageData.post_categories.find(
					(i) => decodeURI(i.slug) === slug
				);
				return matchedCat ? matchedCat.term_id : false;
			},
		},
		components: {
			BlogPost,
			FeaturedPost,
			Pagination,
		},
	};
</script>

<style lang="sass" scoped>

	$grey1: #f7f7f7
	$grey2: #eaeaea
	$red: #ea4725
	$white: #ffffff
	$black: #000000
	$dark: #213519
	$green: #cbe5c0

	.ta-center
		text-align: center

	.fw-bold
		font-weight: bold

	.mobile-only
		display: none

	.desktop-only
		display: block

	.loader
		display: flex
		justify-content: center
		img
			width: 5rem

	section.banner
		position: relative
		background-size: cover
		background-position: top center
		color: $dark
		width: 100%
		overflow: hidden

		.container
			display: flex
			flex-direction: column
			padding: 3rem 0 5rem 0
			justify-content: center
			align-items: center
			text-align: center

		.pre-title
			margin-bottom: 1.5rem
			span
				display: inline-block
				padding: 0.5rem 2rem
				background-color: $red
				color: $white
				border-radius: 10rem
				border-top-right-radius: 0rem

		.title
			font-family: 'raanancondensed'
			font-size: 3.85rem
			margin-bottom: 0

		.heading-text
			margin: 1.5rem auto 0 auto
			width: 47vw
			::v-deep p
				margin-bottom: 0.85rem
				&:last-child
					margin-bottom: 0

	section.featured
		padding: 3rem 0

		h3
			margin-bottom: 2rem

		.posts
			display: flex
			gap: 4rem
			flex-wrap: nowrap

	section.posts-by-cat

		padding: 3rem 0
		background-color: $white

		.slider-nav
			background: transparent
			outline: none
			border: none
			position: absolute
			top: 0.85rem
			left: 0
			z-index: 3
			span
				border-left: 2px solid $dark
				border-bottom: 2px solid $dark
				display: inline-block
				width: 0.85rem
				height: 0.85rem
				transform: rotate(45deg)
			&.prev
				left: auto
				right: 0
				span
					transform: rotate(225deg)


		.categories-container
			display: flex
			align-items: center
			margin-bottom: 3rem

			& > p
				white-space: nowrap
				margin-left: 2rem

		.categories
			display: flex
			align-items: center
			margin-bottom: 0
			padding: 0 1rem 1rem 2rem
			position: relative
			width: 100%
			overflow: scroll
			transform: translateY(0.5rem)
			.category
				list-style-type: none
				margin-bottom: 0
				&:before
					display: none
			button
				background: transparent
				border-radius: 2rem
				padding: 0.25rem 1.5rem
				border: 1px solid darken($grey2, 20%)
				white-space: nowrap
				&:focus, &:hover, &.selected
					background-color: $dark
					color: $green
					border: 1px solid $green

		.categories-scroll-container
			position: relative
			width: 100%
			overflow: hidden
			&:before, &:after
				z-index: 2
				content: ''
				position: absolute
				background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)
				// background: linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,0,0,0) 100%)
				top: 0
				left: 0
				width: 3rem
				height: 100%
			&:after
				left: auto
				right: 0
				transform: rotate(180deg)

		.posts
			display: flex
			flex-wrap: wrap
			gap: 3rem

	/* MOBILE */
	@media screen and (max-width: 800px)
		.mobile-only
			display: block
		.desktop-only
			display: none

		section.banner

			.container
				padding-top: 2rem
				padding-bottom: 1.5rem

			.pre-title
				margin: 1rem auto 0 auto
				span
					font-size: 0.85rem
					padding: 0.25rem 1rem
			.title




				margin-top: 0
				font-size: 3.25rem

		section.featured
			background-color: $grey2
			.posts
				flex-wrap: wrap
				gap: 2.25rem

		.mobile-heading-text-container
			padding: 1rem 0 2rem 0

		section.posts-by-cat
			text-align: center

			.categories-container
				display: block

				& > p
					margin-left: 0
					margin-bottom: 1rem

			.posts
				flex-wrap: wrap
</style>
